"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _trackChange = _interopRequireDefault(require("settings-ui-lib/utils/trackChange"));

var _UIToggle = _interopRequireDefault(require("UIComponents/input/UIToggle"));

var _UIMultiColumn = _interopRequireDefault(require("UIComponents/layout/UIMultiColumn"));

var _UIMultiColumnGroup = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnGroup"));

var _UIMultiColumnItem = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnItem"));

var TOGGLE_ID = 'forms-create-emailless-contact';

var EmaillessContacts =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(EmaillessContacts, _PureComponent);
  (0, _createClass2.default)(EmaillessContacts, null, [{
    key: "propTypes",
    get: function get() {
      return {
        enabled: _propTypes.default.bool.isRequired,
        readOnly: _propTypes.default.bool.isRequired,
        onEnabledChanged: _propTypes.default.func.isRequired
      };
    }
  }]);

  function EmaillessContacts(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmaillessContacts);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EmaillessContacts).call(this, props));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EmaillessContacts, [{
    key: "handleChange",
    value: function handleChange(evt) {
      var onEnabledChanged = this.props.onEnabledChanged;
      (0, _trackChange.default)(TOGGLE_ID + "-enabled");
      onEnabledChanged(evt.target.checked);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          enabled = _this$props.enabled,
          readOnly = _this$props.readOnly;
      return _react.default.createElement(_UIMultiColumn.default, {
        id: TOGGLE_ID
      }, _react.default.createElement(_UIMultiColumnGroup.default, null, _react.default.createElement(_UIMultiColumnItem.default, {
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: 'marketing.forms.toggle.title'
        })
      }, _react.default.createElement(_FormattedMessage.default, {
        message: 'marketing.forms.toggle.description'
      })), _react.default.createElement(_UIMultiColumnItem.default, null, _react.default.createElement(_UIToggle.default, {
        checked: enabled,
        disabled: readOnly,
        onChange: this.handleChange
      }))));
    }
  }]);
  return EmaillessContacts;
}(_react.PureComponent);

var _default = EmaillessContacts;
exports.default = _default;
module.exports = exports.default;